import { render, staticRenderFns } from "./TabWiki.vue?vue&type=template&id=7960cf68&"
import script from "./TabWiki.vue?vue&type=script&lang=js&"
export * from "./TabWiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports